// icons.js
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faDownload,
  faPlay,
  faPause,
  faArrowDown,
} from "@fortawesome/free-solid-svg-icons";

// Adding all icons to use globally
library.add(faDownload, faArrowDown, faPlay, faPause);
